module.exports = __webpack_public_path__ + "static/img/logo.b96a5b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1